import React, { useState } from "react";
import { LiveKitRoom, VideoConference } from "@livekit/components-react";
import "@livekit/components-styles";

export default function Meeting() {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState("");
  const [room, setRoom] = useState("testroom");
  const [joined, setJoined] = useState(false);

  const joinRoom = async () => {
    if (!user) return alert("Please enter your name");

    try {
      const res = await fetch(process.env.REACT_APP_TOKEN_SERVER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user, room }),
      });

      const data = await res.json();
      setToken(data.token);
      setJoined(true);
    } catch (err) {
      console.error("Token fetch error:", err);
      alert("Failed to get token");
    }
  };

  if (!joined) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <h1 className="text-2xl font-bold mb-4">Join LiveKit Meeting</h1>

        <input
          type="text"
          placeholder="Your Name"
          value={user}
          onChange={(e) => setUser(e.target.value)}
          className="border rounded px-3 py-2 mb-3"
        />

        <input
          type="text"
          placeholder="Room Name"
          value={room}
          onChange={(e) => setRoom(e.target.value)}
          className="border rounded px-3 py-2 mb-3"
        />

        <button
          onClick={joinRoom}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Join Room
        </button>
      </div>
    );
  }

  return (
    <LiveKitRoom
      token={token}
      serverUrl="wss://livekit.fstacks.com"
      connect={true}
      video={true}
      audio={true}
      data-lk-theme="default"
      onDisconnected={() => {
        setJoined(false);
        setToken(null);
      }}
      style={{ height: "100vh" }}
    >
      <VideoConference />
    </LiveKitRoom>
  );
}
